(function($) {
	'use strict';

	$.widget('msv.tabspanel', {

		options: {
			duration: .6
		},

		_create: function() {
			var self = this;
			this.options.myfilet = this.element.find("span.filet");
			this.element.tabs({
				show: true,
				beforeActivate: function(_, ui) {
					var newone = $(ui.newTab);
					TweenMax.to(self.options.myfilet, self.options.duration, {
						left: newone.position().left,
						width: newone.width(),
						ease: Power4.easeOut
					});
				},
				create: function() {
					var amount = self.element.find(".small-slider__tab-item").length;
					self.options.myfilet.css({
						width: (1 / amount) * 100 + '%'
					});
				}
			});

			$(window).on('resize', function() {
				if (self.element.is(":visible")) {
					self._redraw();
				}
			});
		},

		_redraw: function() {
			var selectedIndex = this.element.find(".ui-tab.ui-tabs-active.ui-state-active").index();
			var width = this.element.find(".small-slider__tab-item").eq(selectedIndex).width();
			var left = this.element.find(".small-slider__tab-item").eq(selectedIndex).position().left;
			this.options.myfilet.css({ width: width, left: left });
		}


	});

})(jQuery);